<!-- cards de Entradas de mercancia -->

<span *ngIf="entradasTotales.ubicados_logicos > 0">
    <br>
    <hr>
    <div class="col-12">
        <h2 class="mb-4">Entradas de mercancia </h2>
    </div>
</span>


<div *ngIf="entradasTotales.ubicados_logicos > 0"
     class="row stats-container animated fadeIn">

    <!-- Ubicados -->
    <div class="col-12 col-lg-3 mb-4">
        <div class="stat-card border-logical">
            <div class="dual-stat">

                <a class="stat-block"
                   routerLink="/panel/entradas_ubicadas_lista/1">
                    <div class="stat-title">Total Ubicadas</div>
                    <div class="stat-value">{{ entradasTotales.ubicados_logicos }}</div>
                    <i class="stat-icon fa-solid fa-server"></i>
                </a>

                <div class="divider"></div>

                <a class="stat-block"
                   [routerLink]="['/panel/entradas_ubicadas_lista/2']">
                    <div class="stat-title">Confirmadas</div>
                    <div class="stat-value">{{ entradasTotales.ubicados_fisicos }}</div>
                    <i class="stat-icon fa-solid fa-warehouse"></i>
                </a>
            </div>
        </div>
    </div>

    <!-- Validadas / No Validadas -->
    <div class="col-12 col-lg-3 mb-4">
        <div class="stat-card border-validated">
            <div class="dual-stat">
                <div class="stat-block">
                    <div class="stat-title">Validadas</div>
                    <div class="stat-value">{{ entradasTotales.validadas }}</div>
                    <i class="stat-icon fa-solid fa-check-double"></i>
                </div>

                <div class="divider"></div>

                <div class="stat-block">
                    <div class="stat-title">No Validadas</div>
                    <div class="stat-value">{{ entradasTotales.no_validadas }}</div>
                    <i class="stat-icon fa-solid fa-clock"></i>
                </div>
            </div>
        </div>
    </div>


    <!-- Origen -->
    <div class="col-12 col-lg-3 mb-4">
        <div class="stat-card border-intranet">
            <div class="dual-stat">

                <div class="stat-block">
                    <div class="stat-title">Origen Intranet</div>
                    <div class="stat-value">{{ entradasTotales.origen_intranet }}</div>
                    <i class="stat-icon fa-solid fa-laptop"></i>
                </div>

                <div class="divider"></div>

                <div class="stat-block">
                    <div class="stat-title">Origen Admin</div>
                    <div class="stat-value">{{ entradasTotales.origen_admin }}</div>
                    <i class="stat-icon fa-solid fa-user-shield"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- Devoluciones / Defectuosos -->
    <div class="col-12 col-lg-3 mb-4">
        <div class="stat-card border-damaged">
            <div class="dual-stat">

                <div class="stat-block">
                    <div class="stat-title">Devoluciones</div>
                    <div class="stat-value">{{ entradasTotales.devoluciones }}</div>
                    <i class="stat-icon fa-solid fa-rotate-left"></i>
                </div>

                <div class="divider"></div>

                <div class="stat-block">
                    <div class="stat-title">Con Defectos</div>
                    <div class="stat-value">{{ entradasTotales.con_defectuosos }}</div>
                    <i class="stat-icon fa-solid fa-triangle-exclamation"></i>
                </div>
            </div>
        </div>
    </div>

</div>